import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react'
import ActionButton from '../../common/input-fields/ActionButton';
import ALTTextField from '../../common/input-fields/ALTTextField';
import { validationMessages } from '../../utils/validationMessages';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { registrationToastMessages, textFormatTypeEnum } from '../../common/input-fields/utils/appInputenum';
import CancelIcon from '@mui/icons-material/Cancel';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import { ToastContainer, toast } from 'react-toastify';
import { createNewUser, updateUser } from '../../services/services';
import { useState } from 'react';

const AddUser = (props) => {

  //#region props
  const { open,selectedUser,onClose,getUsers } = props;

  //#region initial data
  const initialData = {
    fullName: selectedUser ? selectedUser.userFullName : '',
    emailAddress: selectedUser ? selectedUser.emailAddress : '',
    phoneNo: selectedUser ? selectedUser.phoneNumber : '',
    designation: selectedUser ? selectedUser.designation : '',
  }

  //#region variables
  const [loading, setLoading] = useState(false);

  //#region change events
  const handleChange = (name,value) => {
    userDetails.setFieldValue(name, value);
  }

  //#region api post calls
  const createUser = async () => {
    setLoading(true);
    const requestedData = {
      "userID": selectedUser ? selectedUser.userID : 0,
      "userFullName": userDetails.values.fullName,
      "genPWD": "string",
      "entraExtIDUserGuid": selectedUser?.entraExtIDUserGuid ? selectedUser?.entraExtIDUserGuid : "string",
      "designation": userDetails.values.designation,
      "emailAddress": userDetails.values.emailAddress,
      "phoneNumber": userDetails.values.phoneNo,
      "createdOn": "2025-07-21T13:23:08.864Z",
      "createdBy": 0,
      "updatedOn": "2025-07-21T13:23:08.864Z",
      "updatedBy": 0,
      "isActive": true,
      "softDelete": true
    }
    let response;
    if (selectedUser) {
      response = await updateUser(requestedData);
    }
    else{
      response = await createNewUser(requestedData);
    }
    if (response.status === 200) {
      getUsers();
      onClose();
      setLoading(false);
      toast.success(registrationToastMessages.USER_CREATED_SUCCESSFULLY, {
        position: "bottom-right",
        theme: "colored",
      });
    }
    else {
      setLoading(false);
      toast.warning(registrationToastMessages.UNABLE_TO_CREATEUSER, {
        position: "bottom-right",
        theme: "colored",
      });
      console.error("Failed to create user:", response);
    }
  }

  //#region formik validations
  const addUserValidationSchema = yup.object().shape({
    fullName: yup
      .string()
      .required(validationMessages.REQUIRED)
      .matches(/^[A-Za-z\s]+$/, "This Field accepts only Alphabets"),
    emailAddress: yup
      .string()
      .required(validationMessages.REQUIRED)
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address."
      ),
    phoneNo: yup
      .string()
      .required(validationMessages.REQUIRED)
      .matches(/^[0-9]+$/, "Please enter valid phone number"),
    designation: yup
      .string()
      .required(validationMessages.REQUIRED),
  }); 

  //#region formik validations
  const userDetails = useFormik({
    initialValues: initialData,
    validationSchema: addUserValidationSchema,
    onSubmit: (values) => {
      createUser();
    },
  });

  //#region return
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add User</DialogTitle>
      <DialogContent>
        <div className='display-row-items-flex'>
          <div className='width-48'>
            <ALTTextField
              variant="standard"
              label="Full Name"
              name="fullName"
              value={userDetails.values.fullName}
              required={true}
              onChange={(name, value) => handleChange(name, value)}
              onBlur={userDetails.handleBlur}
              error={userDetails.touched.fullName && Boolean(userDetails.errors.fullName)}
              errorMessage={userDetails.touched.fullName && userDetails.errors.fullName} />
          </div>
          <div className='width-48'>
            <ALTTextField
              label="Email Address"
              name="emailAddress"
              value={userDetails.values.emailAddress}
              onChange={(name, value) => handleChange(name, value)}
              required={true}
              readOnly={selectedUser ? true : false}
              onBlur={userDetails.handleBlur}
              error={userDetails.touched.emailAddress && Boolean(userDetails.errors.emailAddress)}
              errorMessage={userDetails.touched.emailAddress && userDetails.errors.emailAddress} />
          </div>
          <div className='width-48'>
            <ALTTextField
              label="Phone Number"
              name="phoneNo"
              value={userDetails.values.phoneNo}
              onChange={(name, value) => handleChange(name, value)}
              required={true}
              onBlur={userDetails.handleBlur}
              error={userDetails.touched.phoneNo && Boolean(userDetails.errors.phoneNo)}
              errorMessage={userDetails.touched.phoneNo && userDetails.errors.phoneNo} />
          </div>
          <div className='width-48'>
            <ALTTextField
              textFormatType={textFormatTypeEnum.ALPHA_NUMERIC}
              label="Designation"
              name="designation"
              value={userDetails.values.designation}
              onChange={(name, value) => handleChange(name, value)}
              required={true}
              onBlur={userDetails.handleBlur}
              error={userDetails.touched.designation && Boolean(userDetails.errors.designation)}
              errorMessage={userDetails.touched.designation && userDetails.errors.designation} />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <ActionButton
          label="Cancel"
          onClick={onClose}
          disabled={loading}
          icon={<CancelIcon />}
          variant="outlined" />
        <ActionButton
          label="Submit"
          icon={<TouchAppIcon />}
          loading={loading}
          onClick={userDetails.handleSubmit}
          variant="contained" />
      </DialogActions>
    </Dialog>
  )
}

export default AddUser